// extracted by mini-css-extract-plugin
module.exports = {"header":"FormHeader_header__3P5fs","title":"FormHeader_title__29ygc","delete":"FormHeader_delete__2IK48"};